(function () {
  function initSection(sectionEl) {
    const mediaItems = sectionEl.querySelectorAll("[data-pdp-media-item]");
    const thumbs = sectionEl.querySelectorAll(".pdp-main__thumb");
    const prevBtn = sectionEl.querySelector('[data-pdp-arrow="prev"]');
    const nextBtn = sectionEl.querySelector('[data-pdp-arrow="next"]');
    
    let currentMediaIndex = 0;

    function updateMedia(mediaId) {
      if (!mediaId || !mediaItems.length) return;
      mediaItems.forEach((item, idx) => {
        const match = String(item.getAttribute("data-media-id")) === String(mediaId);
        item.hidden = !match;
        item.classList.toggle("is-active", match);
        if (match) currentMediaIndex = idx;
        else {
          const v = item.querySelector("video");
          if (v && !v.paused) v.pause();
        }
      });
      thumbs.forEach(btn => {
        const isActive = String(btn.getAttribute("data-target-media-id")) === String(mediaId);
        btn.classList.toggle("is-active", isActive);
        btn.setAttribute("aria-selected", isActive ? "true" : "false");
      });
    }

    function shiftMedia(dir) {
      if (!mediaItems.length) return;
      currentMediaIndex = (currentMediaIndex + dir + mediaItems.length) % mediaItems.length;
      updateMedia(mediaItems[currentMediaIndex].getAttribute("data-media-id"));
    }

    if (prevBtn) prevBtn.addEventListener("click", (e) => { e.preventDefault(); shiftMedia(-1); });
    if (nextBtn) nextBtn.addEventListener("click", (e) => { e.preventDefault(); shiftMedia(1); });
    
    thumbs.forEach(btn => btn.addEventListener("click", (e) => {
      e.preventDefault();
      updateMedia(btn.getAttribute("data-target-media-id"));
    }));

    const activeThumb = sectionEl.querySelector(".pdp-main__thumb.is-active");
    if (activeThumb) updateMedia(activeThumb.getAttribute("data-target-media-id"));

    const primaryInputs = sectionEl.querySelectorAll('.js-primary-selector');
    const variantItems = sectionEl.querySelectorAll('.js-variant-item');
    const secondaryInputs = sectionEl.querySelectorAll('input[name="secondary-selection"]');
    
     if (!primaryInputs.length && !secondaryInputs.length) {
      removeSkeleton(sectionEl);
      return;
    }

    const finalVariantInput = sectionEl.querySelector('#product-select-id');
    const finalSellingPlanInput = sectionEl.querySelector('#product-selling-plan-id');
    const extraVariantInputs = sectionEl.querySelectorAll('.js-variant-id');
    const buyButtonPrice = sectionEl.querySelectorAll('.js-button-price');
    const buyButtonSubPrice = sectionEl.querySelectorAll('.js-subscription-button-price');
    const addToCartBtns = sectionEl.querySelectorAll('button[name="add"]');

    function isSoldOut(el) {
      if (!el) return true;
      return el.disabled || el.getAttribute('data-available') === 'false' || (el.closest('.js-variant-item, .payment-plan__option, .pdp-main__tile')?.classList.contains('is-disabled'));
    }

    function syncUI(selectedRadio) {
      if (!selectedRadio) return;
      const vId = selectedRadio.value;
      const url = new URL(window.location.href);
      
      if (url.searchParams.get("variant") !== vId) {
        url.searchParams.set("variant", vId);
        window.history.replaceState({ path: url.toString() }, "", url.toString());
      }

      primaryInputs.forEach(r => {
        const t = r.closest(".pdp-main__tile");
        if (t) t.classList.toggle("is-active", r.checked);
      });
      secondaryInputs.forEach(r => {
        const t = r.closest(".js-variant-item") || r.closest(".payment-plan__option");
        if (t) t.classList.toggle("is-active", r.checked);
      });

      const soldOut = isSoldOut(selectedRadio);
      addToCartBtns.forEach(btn => {
        btn.disabled = soldOut;

        if(soldOut) {
          btn.querySelector('.js-btn-available').style.display = 'none';
          btn.querySelector('.js-btn-unavailable').style.display = 'inline';
          document.querySelectorAll('.js-txt-below-btn')?.forEach(txt => txt.style.display = 'none');
          document.querySelectorAll('.js-txt-below-btn-out-of-stock')?.forEach(txt => txt.style.display = 'inline');
        } else {
          btn.querySelector('.js-btn-available').style.display = 'inline';
          btn.querySelector('.js-btn-unavailable').style.display = 'none';
          document.querySelectorAll('.js-txt-below-btn')?.forEach(txt => txt.style.display = 'inline');
          document.querySelectorAll('.js-txt-below-btn-out-of-stock')?.forEach(txt => txt.style.display = 'none');
        }

        btn.classList.toggle('is-disabled', soldOut);
        btn.classList.toggle('sold-out', soldOut);
      });

      if (finalVariantInput) finalVariantInput.value = vId;
      if (finalSellingPlanInput) finalSellingPlanInput.value = selectedRadio.getAttribute('data-selling-plan') || '';

      const p = selectedRadio.getAttribute('data-price');
      const sp = selectedRadio.getAttribute('data-sub-price');
      const cp = selectedRadio.getAttribute('data-compare-at-price');

      if(cp) {
        buyButtonPrice.forEach(el => el.textContent = cp);
      } else {
        buyButtonPrice.forEach(el => el.textContent = p);
      }

      if (sp) {
        buyButtonPrice.forEach(el => el.style.display = 'inline-block');
        buyButtonSubPrice.forEach(el => el.textContent = sp);
      } else {
        if(!cp) {
          buyButtonPrice.forEach(el => el.style.display = 'none');
        }
        buyButtonSubPrice.forEach(el => el.textContent = p);
      }

      const bottleLabel = selectedRadio.getAttribute('data-bottle-label');
      const bottleLabelEl = sectionEl.querySelector('.js-variant-bottle-label');
      if (bottleLabelEl) bottleLabelEl.textContent = bottleLabel;

      const prim = sectionEl.querySelector('.js-primary-selector:checked');
      if (prim) updateMedia(prim.getAttribute('data-variant-media-id'));

      extraVariantInputs.forEach(i => {
        if (i.value !== vId) {
          i.value = vId;
          try { i.dispatchEvent(new Event('change', { bubbles: true })); } catch(e) {}
        }
      });
    }

    primaryInputs.forEach(input => {
      const tile = input.closest('.pdp-main__tile');
      if (tile) {
        tile.addEventListener('click', (e) => {
          if (e.target.tagName === 'INPUT') return;
          if (!input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change'));
          }
        });
      }

      input.addEventListener('change', function() {
        const val = this.value;
        let actIdx = 0;
        let visibleCount = 0;
        
        variantItems.forEach(item => {
          if (item.style.display !== 'none') {
            if (item.querySelector('input').checked) actIdx = visibleCount;
            visibleCount++;
          }
        });

        const newGrp = [];
        variantItems.forEach(item => {
          const isDefault = item.classList.contains('js-variant-item-default-option');
          if (item.getAttribute('data-parent') === val || isDefault) {
            item.style.display = 'block';
            if (!isDefault) newGrp.push(item);
          } else {
            item.style.display = 'none';
            const r = item.querySelector('input');
            if (r) r.checked = false;
          }
        });

        if (newGrp.length > 0) {
          let tgt = newGrp[Math.min(actIdx, newGrp.length - 1)].querySelector('input');
          if (isSoldOut(tgt)) {
            const avail = newGrp.find(i => !isSoldOut(i.querySelector('input')));
            if (avail) tgt = avail.querySelector('input');
          }
          tgt.checked = true;
          syncUI(tgt);
        }
      });
    });

    variantItems.forEach(item => {
      const radio = item.querySelector('input');
      item.addEventListener('click', e => {

        if (e.target.tagName !== 'INPUT' && radio && !radio.checked) {
          radio.checked = true;
          syncUI(radio);
        }
      });
      if (radio) {
        radio.addEventListener('change', function() {
          if (this.checked) syncUI(this);
        });
      }
    });

    const urlVar = new URLSearchParams(window.location.search).get('variant');
    const allSec = Array.from(secondaryInputs);
    let start = urlVar ? allSec.find(r => r.value === urlVar) : allSec.find(r => r.checked);
    
    if (!start || isSoldOut(start)) {
      start = allSec.find(r => !isSoldOut(r)) || allSec[0];
      removeSkeleton(sectionEl);
    }

    if (start) {
      const pHandle = start.closest('.js-variant-item').getAttribute('data-parent');
      const mPrim = Array.from(primaryInputs).find(p => p.value === pHandle);
      if (mPrim) mPrim.checked = true;

      variantItems.forEach(item => {
        const isDefault = item.classList.contains('js-variant-item-default-option');
        const isOneTime = item.classList.contains('js-variant-item-one-time');

        if (item.getAttribute('data-parent') === pHandle || isDefault || isOneTime) {
          item.style.display = 'block';
        } else {
          item.style.display = 'none';
          const r = item.querySelector('input');
          if (r) r.checked = false;
        }
      });

      start.checked = true;
      syncUI(start);
      
      removeSkeleton(sectionEl);
    }
  }

  function removeSkeleton(section) {
    if(section.querySelectorAll(".js-skeleton-wrapper").length) {
      setTimeout(function() {
        section.querySelectorAll(".js-skeleton-wrapper")?.forEach(skeleton => {
          skeleton.querySelector('.js-skeleton-item').remove();
          skeleton.classList.remove('skeleton-wrapper');
        });
      }, 300);
    }
  }

  function initAll() {
    const sections = document.querySelectorAll(".shopify-section");
    let found = false;
    sections.forEach(s => {
      if (s.querySelector('.js-primary-selector') || s.querySelector('[data-pdp-media-item]')) {
        initSection(s);
        found = true;
      }
    });
    if (!found) initSection(document);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener("shopify:section:load", e => {
    if (e.target) initSection(e.target);
  });
})();